import { Button } from 'rbx';
import * as React from 'react';
import { useMutation } from '@apollo/client';

import { BASKET_LINE_ITEMS_QUERY } from './../../../api/GraphQLQueries/Basket';
import { LINE_ITEM_DELETE_MUTATION } from './../../../api/GraphQLQueries/LineItem';
import { notification } from './../../../utils/notification';

interface IProps {
    id: number;
    basketId: string;
}

const LineItemDeleteMutation: React.FC<IProps> = ({ id, basketId }) => {

    const [deleteLineItem] = useMutation(LINE_ITEM_DELETE_MUTATION, {
        onCompleted: () => {
            notification.success('Successfully deleted item');
        },
        onError: () => {
            notification.error('Item delete error');
        },
        refetchQueries: basketId
            ? [{ query: BASKET_LINE_ITEMS_QUERY, variables: { id: basketId } }]
            : [],
    });

    const handleDelete = () => {
        if (window.confirm(`Are you sure? This action can not be undone.`)) {
            deleteLineItem({ variables: { id } });
        }
    };

    return (
        <Button size="small" text={true} onClick={handleDelete}>
            Delete
        </Button>
    );
};

export default LineItemDeleteMutation;
